// biome-ignore lint/performance/noBarrelFile: intentional
export { toSignatureHash as toFunctionHash, } from './toSignatureHash.js';
//# sourceMappingURL=toFunctionHash.js.map